// DO NOT EDIT THIS FILE. THIS FILE IS CREATED BY `create-icon-component.js` SCRIPT
import * as Icons from "./components";
export var iconNames = ["2-people", "android", "angle-down", "angle-left", "angle-right", "angle-up", "apple", "archive-trash", "arrow-down", "arrow-left", "arrow-next", "arrow-right", "arrow-up", "at-mark", "b", "back", "balloon-cross-ol", "balloon-ol", "balloon", "balloons-cross-ol", "balloons-ol", "balloons", "bar-chart", "beginner", "bell-ol", "bell-slash", "bell", "bookmark-ol", "bookmark", "bulb", "business-bag-ol", "business-bag", "calendar", "camera-ol", "camera", "certification", "check-circle", "check", "chevron-down", "chevron-left", "chevron-right", "chevron-up", "child", "circle", "clock-ol", "clock", "close-circle-ol", "close-circle", "close", "code", "company-ol", "company-plus-ol", "company-plus", "company", "compass-ol", "compass", "connection", "copy", "crip", "cutlery", "dashboard", "device-desktop", "device-mobile", "documents", "door-ol", "door", "download-circle-ol", "download-circle", "download-cloud-ol", "download-clowd", "download", "exclamation-circle-ol", "exclamation-circle", "eyes", "facebook-circle", "facebook", "file-ol", "file", "finger", "fire", "flag", "folder-ol", "folder", "fullscreen-exit", "fullscreen", "funnel", "gear", "github", "google", "h2", "h3", "handle", "hash", "hatena", "heart-ol", "heart", "history", "info", "information-ol", "instagram", "items", "jagged-badge", "jump", "keyboard", "label-text-ol", "label-text", "linechart", "link", "linkedin", "list-plus", "list", "location-pin", "location", "lock", "mail-ol", "mail", "megaphone", "menu", "message-ol", "message", "minus", "more-holizontal", "more-horizontal", "more-vertical", "newspaper-ol", "newspaper", "number", "pause", "pencil-paper", "pencil-plus", "pencil", "person-circle", "person-ol", "person-plus-ol", "person-plus", "person", "phone", "picture", "pin", "plane-circle", "planet", "play", "plus-circle", "plus", "pool", "present", "printer", "pulse", "puzzle", "qr", "quote", "refresh", "reply", "right-pane", "search-minus", "search-plus", "search-short", "search", "send", "separator", "share-android", "share-ios", "share", "shere-ms", "sliders", "sort", "spanner", "star-ol", "star", "sync", "tag-ol", "tag", "target", "template", "text-square-ol", "text-square", "thumb-up-ol", "thumb-up", "trash-ol", "trash", "trencher-ol", "trencher", "triangle-down", "triangle-up", "triangle", "trophy", "tshirt", "twitter", "two-people", "undo", "wand", "wanted", "wantedly-circle", "wantedly", "whatsapp-ol", "whatsapp", "windows", "x", "youtube"];
export var iconNameAndRendererMap = {
  "2-people": Icons.TwoPeople,
  "android": Icons.Android,
  "angle-down": Icons.AngleDown,
  "angle-left": Icons.AngleLeft,
  "angle-right": Icons.AngleRight,
  "angle-up": Icons.AngleUp,
  "apple": Icons.Apple,
  "archive-trash": Icons.ArchiveTrash,
  "arrow-down": Icons.ArrowDown,
  "arrow-left": Icons.ArrowLeft,
  "arrow-next": Icons.ArrowNext,
  "arrow-right": Icons.ArrowRight,
  "arrow-up": Icons.ArrowUp,
  "at-mark": Icons.AtMark,
  "b": Icons.B,
  "back": Icons.Back,
  "balloon-cross-ol": Icons.BalloonCrossOl,
  "balloon-ol": Icons.BalloonOl,
  "balloon": Icons.Balloon,
  "balloons-cross-ol": Icons.BalloonsCrossOl,
  "balloons-ol": Icons.BalloonsOl,
  "balloons": Icons.Balloons,
  "bar-chart": Icons.BarChart,
  "beginner": Icons.Beginner,
  "bell-ol": Icons.BellOl,
  "bell-slash": Icons.BellSlash,
  "bell": Icons.Bell,
  "bookmark-ol": Icons.BookmarkOl,
  "bookmark": Icons.Bookmark,
  "bulb": Icons.Bulb,
  "business-bag-ol": Icons.BusinessBagOl,
  "business-bag": Icons.BusinessBag,
  "calendar": Icons.Calendar,
  "camera-ol": Icons.CameraOl,
  "camera": Icons.Camera,
  "certification": Icons.Certification,
  "check-circle": Icons.CheckCircle,
  "check": Icons.Check,
  "chevron-down": Icons.ChevronDown,
  "chevron-left": Icons.ChevronLeft,
  "chevron-right": Icons.ChevronRight,
  "chevron-up": Icons.ChevronUp,
  "child": Icons.Child,
  "circle": Icons.Circle,
  "clock-ol": Icons.ClockOl,
  "clock": Icons.Clock,
  "close-circle-ol": Icons.CloseCircleOl,
  "close-circle": Icons.CloseCircle,
  "close": Icons.Close,
  "code": Icons.Code,
  "company-ol": Icons.CompanyOl,
  "company-plus-ol": Icons.CompanyPlusOl,
  "company-plus": Icons.CompanyPlus,
  "company": Icons.Company,
  "compass-ol": Icons.CompassOl,
  "compass": Icons.Compass,
  "connection": Icons.Connection,
  "copy": Icons.Copy,
  "crip": Icons.Crip,
  "cutlery": Icons.Cutlery,
  "dashboard": Icons.Dashboard,
  "device-desktop": Icons.DeviceDesktop,
  "device-mobile": Icons.DeviceMobile,
  "documents": Icons.Documents,
  "door-ol": Icons.DoorOl,
  "door": Icons.Door,
  "download-circle-ol": Icons.DownloadCircleOl,
  "download-circle": Icons.DownloadCircle,
  "download-cloud-ol": Icons.DownloadCloudOl,
  "download-clowd": Icons.DownloadClowd,
  "download": Icons.Download,
  "exclamation-circle-ol": Icons.ExclamationCircleOl,
  "exclamation-circle": Icons.ExclamationCircle,
  "eyes": Icons.Eyes,
  "facebook-circle": Icons.FacebookCircle,
  "facebook": Icons.Facebook,
  "file-ol": Icons.FileOl,
  "file": Icons.File,
  "finger": Icons.Finger,
  "fire": Icons.Fire,
  "flag": Icons.Flag,
  "folder-ol": Icons.FolderOl,
  "folder": Icons.Folder,
  "fullscreen-exit": Icons.FullscreenExit,
  "fullscreen": Icons.Fullscreen,
  "funnel": Icons.Funnel,
  "gear": Icons.Gear,
  "github": Icons.Github,
  "google": Icons.Google,
  "h2": Icons.H2,
  "h3": Icons.H3,
  "handle": Icons.Handle,
  "hash": Icons.Hash,
  "hatena": Icons.Hatena,
  "heart-ol": Icons.HeartOl,
  "heart": Icons.Heart,
  "history": Icons.History,
  "info": Icons.Info,
  "information-ol": Icons.InformationOl,
  "instagram": Icons.Instagram,
  "items": Icons.Items,
  "jagged-badge": Icons.JaggedBadge,
  "jump": Icons.Jump,
  "keyboard": Icons.Keyboard,
  "label-text-ol": Icons.LabelTextOl,
  "label-text": Icons.LabelText,
  "linechart": Icons.Linechart,
  "link": Icons.Link,
  "linkedin": Icons.Linkedin,
  "list-plus": Icons.ListPlus,
  "list": Icons.List,
  "location-pin": Icons.LocationPin,
  "location": Icons.Location,
  "lock": Icons.Lock,
  "mail-ol": Icons.MailOl,
  "mail": Icons.Mail,
  "megaphone": Icons.Megaphone,
  "menu": Icons.Menu,
  "message-ol": Icons.MessageOl,
  "message": Icons.Message,
  "minus": Icons.Minus,
  "more-holizontal": Icons.MoreHolizontal,
  "more-horizontal": Icons.MoreHorizontal,
  "more-vertical": Icons.MoreVertical,
  "newspaper-ol": Icons.NewspaperOl,
  "newspaper": Icons.Newspaper,
  "number": Icons.Number,
  "pause": Icons.Pause,
  "pencil-paper": Icons.PencilPaper,
  "pencil-plus": Icons.PencilPlus,
  "pencil": Icons.Pencil,
  "person-circle": Icons.PersonCircle,
  "person-ol": Icons.PersonOl,
  "person-plus-ol": Icons.PersonPlusOl,
  "person-plus": Icons.PersonPlus,
  "person": Icons.Person,
  "phone": Icons.Phone,
  "picture": Icons.Picture,
  "pin": Icons.Pin,
  "plane-circle": Icons.PlaneCircle,
  "planet": Icons.Planet,
  "play": Icons.Play,
  "plus-circle": Icons.PlusCircle,
  "plus": Icons.Plus,
  "pool": Icons.Pool,
  "present": Icons.Present,
  "printer": Icons.Printer,
  "pulse": Icons.Pulse,
  "puzzle": Icons.Puzzle,
  "qr": Icons.Qr,
  "quote": Icons.Quote,
  "refresh": Icons.Refresh,
  "reply": Icons.Reply,
  "right-pane": Icons.RightPane,
  "search-minus": Icons.SearchMinus,
  "search-plus": Icons.SearchPlus,
  "search-short": Icons.SearchShort,
  "search": Icons.Search,
  "send": Icons.Send,
  "separator": Icons.Separator,
  "share-android": Icons.ShareAndroid,
  "share-ios": Icons.ShareiOS,
  "share": Icons.Share,
  "shere-ms": Icons.ShereMs,
  "sliders": Icons.Sliders,
  "sort": Icons.Sort,
  "spanner": Icons.Spanner,
  "star-ol": Icons.StarOl,
  "star": Icons.Star,
  "sync": Icons.Sync,
  "tag-ol": Icons.TagOl,
  "tag": Icons.Tag,
  "target": Icons.Target,
  "template": Icons.Template,
  "text-square-ol": Icons.TextSquareOl,
  "text-square": Icons.TextSquare,
  "thumb-up-ol": Icons.ThumbUpOl,
  "thumb-up": Icons.ThumbUp,
  "trash-ol": Icons.TrashOl,
  "trash": Icons.Trash,
  "trencher-ol": Icons.TrencherOl,
  "trencher": Icons.Trencher,
  "triangle-down": Icons.TriangleDown,
  "triangle-up": Icons.TriangleUp,
  "triangle": Icons.Triangle,
  "trophy": Icons.Trophy,
  "tshirt": Icons.Tshirt,
  "twitter": Icons.Twitter,
  "two-people": Icons.TwoPeople,
  "undo": Icons.Undo,
  "wand": Icons.Wand,
  "wanted": Icons.Wanted,
  "wantedly-circle": Icons.WantedlyCircle,
  "wantedly": Icons.Wantedly,
  "whatsapp-ol": Icons.WhatsappOl,
  "whatsapp": Icons.Whatsapp,
  "windows": Icons.Windows,
  "x": Icons.X,
  "youtube": Icons.Youtube
};
//# sourceMappingURL=iconNames.js.map